<template>
	<div>
		<el-card class="box-card">
			<el-form label-width="80px">
				<el-form-item label="平台类型:">
					<el-radio-group v-model="listQuery.search.platform" @change="platformChange">
						<el-radio label="" border>全部</el-radio>
						<el-radio :label="item.id.toString()" v-for="item in platform_list" border>{{item.name}}
						</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="任务状态:">
					<el-radio-group v-model="listQuery.search.state" size="small" @change="stateChange">
						<el-radio-button label="">全部任务</el-radio-button>
						<el-radio-button :label="item.value.toString()" v-for="item in state_all">{{item.label}}
						</el-radio-button>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="高级搜索:">
					<el-col :span="2">
						<el-input v-model="listQuery.search.id" placeholder="任务ID" clearable></el-input>
					</el-col>
					<el-col :span="3" style="margin-left: 5px;">
						<el-select v-model="listQuery.search.shop_id" placeholder="请选择">
							<el-option label="请选择店铺" value=""></el-option>
							<el-option v-for="item in store_list" :key="item.id" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</el-col>
					<el-col :span="8" style="margin-left: 5px;">
						<el-date-picker style="width: 38%;" v-model="listQuery.search.start_time" type="date" placeholder="发布任务的开始日期">
						</el-date-picker>
						-
						<el-date-picker style="width: 38%;" v-model="listQuery.search.end_time" type="date" placeholder="发布任务的结束日期">
						</el-date-picker>
					</el-col>
					<el-col :span="2">
						<el-button type="primary" icon="el-icon-search" @click="keySearch">搜索</el-button>
					</el-col>
					<el-col :span="2">
						<el-button type="success" style="margin-left:50px;" plain @click="excel"><i class="el-icon-download"></i>
							导出数据</el-button>
					</el-col>
				</el-form-item>
			</el-form>
		</el-card>
		<div style="margin-top:30px">
			<el-table v-loading="loading" :data="data_list" stripe style="width: 100%" size="small">
				<el-table-column type="expand">
					<template slot-scope="props">
						<el-form label-position="left" inline class="demo-table-expand">
							<el-divider content-position="left"><h3>基础信息</h3></el-divider>
							<el-form-item label="商品链接:">
								<el-tooltip class="item" effect="dark" :content="props.row.goods_links" placement="top-start">
								    <el-link type="primary" :href="props.row.goods_links" target="_blank">点击跳转</el-link>
								</el-tooltip>
							</el-form-item>
							<el-form-item label="商品名称:">
								<span>{{props.row.goods_name}}</span>
							</el-form-item>
							<el-form-item label="商品主图:">
								<el-image v-if="props.row.goods_img" style="width: 40px; height: 40px"
									:src="props.row.goods_img" fit="fill" :preview-src-list="[props.row.goods_img]">
								</el-image>
							</el-form-item>
							<el-form-item label="商品SKU:">
								<span>{{props.row.goods_sku}}</span>
							</el-form-item>
							<el-form-item label="商品单价:">
								<span>{{props.row.goods_price}} ({{props.row.coin_name}})</span>
							</el-form-item>
							<el-form-item label="商品单价(RMB):">
								<span>{{props.row.goods_price_rmb}}</span>
							</el-form-item>
							<el-form-item label="每单数量:">
								<span>{{props.row.goods_num}}</span>
							</el-form-item>
							<el-form-item label="任务数量:">
								<span>{{props.row.task_num}}</span>
							</el-form-item>
							<el-form-item label="是否包邮:">
								<span>{{props.row.is_fs_init}}</span>
							</el-form-item>
							<el-form-item label="预扣邮费:">
								<span v-if="props.row.currency_type == 0">¥ {{props.row.fs_money}}</span>
								<span v-if="props.row.currency_type != 0">{{props.row.fs_money_out}}({{props.row.coin_name}})</span>
							</el-form-item>
							<el-form-item label="发布时间:">
								<span>{{ props.row.public_time | parseTime('{y}-{m}-{d}') }}</span>
							</el-form-item>
							<el-divider content-position="left"><h3>进店方式</h3></el-divider>
							<el-form-item label="进店方式:">
								<span>{{props.row.in_shop_way_init}}</span>
								<el-button style="margin-left: 10px;" type="primary"
									@click="showIn1(props.row.in_keyword_data)"><i class="el-icon-search"></i> 搜索关键词配置
								</el-button>
								<el-button type="primary" @click="showIn2(props.row.in_other_data)"><i
										class="el-icon-search"></i> 其他渠道配置</el-button>
							</el-form-item>
							<el-divider content-position="left"><h3>千人千面</h3></el-divider>
							<el-form-item label="店铺Follow关注:">
								<span>{{props.row.is_follow_init}}</span>
							</el-form-item>
							<el-form-item label="产品心愿单:">
								<span>{{props.row.is_wish_init}}</span>
							</el-form-item>
							<el-form-item label="要求加入购物车:">
								<span>{{props.row.is_car_init}}</span>
							</el-form-item>
							<el-form-item label="Chat在线聊天:">
								<span>{{props.row.is_chat_init}}</span>
							</el-form-item>
							<el-divider content-position="left"><h3>增值服务</h3></el-divider>
							<el-form-item label="货比数量:">
								<span>{{props.row.hb_num_init}}</span>
							</el-form-item>
							<el-form-item label="浏览商品数量:">
								<span>{{props.row.look_num_init}}</span>
							</el-form-item>
							<el-form-item label="搭配商品:">
								<span>{{props.row.is_collocation_init}}</span>
								<el-button style="margin-left: 10px;" type="primary"
									@click="showCollocation(props.row.collocation)">
									<i class="el-icon-search"></i> 搭配商品配置
								</el-button>
							</el-form-item>
							<el-form-item label="优惠券:">
								<span>{{props.row.is_coupon_init}}</span>
							</el-form-item>
							<el-form-item label="优惠券链接:">
								<el-link type="primary" :href="props.row.coupon_links" target="_blank">{{props.row.coupon_links}}</el-link>
							</el-form-item>
							<el-divider content-position="left"><h3>其他</h3></el-divider>
							<el-form-item label="追加红包(RMB):">
								<span>{{props.row.lucky_money}}</span>
							</el-form-item>
							<el-form-item label="模板名称:">
								<span>{{props.row.template_name}}</span>
							</el-form-item>
							<el-form-item label="留言提醒:">
								<span>{{props.row.message}}</span>
							</el-form-item>
							<el-divider content-position="left"><h3>任务费用预算</h3></el-divider>
							<el-form-item label="商品单价(总):">
								<span v-if="props.row.currency_type == 0">¥ {{props.row.total.goods_price}}</span>
								<span v-if="props.row.currency_type != 0">{{props.row.total.goods_price_out}}({{props.row.coin_name}})</span>
							</el-form-item>
							<el-form-item label="基础服务费(总):">
								<span>¥ {{props.row.total.base_cost}}</span>
							</el-form-item>
							<el-form-item label="增值服务费(总):">
								<span>¥ {{props.row.total.s_cost}}</span>
							</el-form-item>
							<el-form-item v-if="props.row.total.over_goods_num_money_val > 0" label="超量服务费(总):">
								<span>¥ {{props.row.total.over_goods_num_money_val}}</span>
							</el-form-item>
							<el-form-item label="追加红包(总):">
								<span>¥ {{props.row.total.lucky_money}}</span>
							</el-form-item>
							<el-form-item label="预扣邮费(总):">
								<span v-if="props.row.currency_type == 0">¥ {{props.row.total.fs_money}}</span>
								<span v-if="props.row.currency_type != 0">{{props.row.total.fs_money_out}}({{props.row.coin_name}})</span>
							</el-form-item>
							<el-form-item label="合计(总):">
								<span>¥ {{props.row.total.total}}</span>
							</el-form-item>
							<el-form-item v-if="props.row.currency_type != 0" label="本金合计:">
								<span>{{props.row.total.total_b_money_out}}({{props.row.coin_name}})</span>
							</el-form-item>
							<el-form-item v-if="props.row.currency_type != 0" label="佣金合计:">
								<span>¥ {{props.row.total.total_y_money_out}}</span>
							</el-form-item>
						</el-form>
					</template>
				</el-table-column>
				<el-table-column prop="id" label="ID"> </el-table-column>
				<el-table-column prop="shop_id_name" label="店铺"> </el-table-column>
				<el-table-column prop="platform_init" label="平台"> </el-table-column>
				<el-table-column prop="country_init" label="国家"> </el-table-column>
				<!-- <el-table-column prop="exchange_rate" label="汇率"> </el-table-column> -->
				<el-table-column prop="task_num" label="任务数量"> </el-table-column>
				<el-table-column prop="draw_task_num" label="已领取"> </el-table-column>
				<el-table-column prop="finish_task_num" label="已完成"> </el-table-column>
				<el-table-column prop="total.total" label="合计(RMB)"> </el-table-column>
				<el-table-column prop="create_time" label="创建时间">
					<template slot-scope="{row}">
						<span>{{ row.create_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
					</template>
				</el-table-column>
				<el-table-column label="状态">
					<template slot-scope="{row}">
						<el-tag :type="row.state_color">
							{{ row.state_init}}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="操作" fixed="right" width="180">
					<template slot-scope="{row,$index}">
						<el-button v-if="[1].includes(row.state)" icon="el-icon-close" @click="cancel(row)"
							size="mini">取消</el-button>
					</template>
				</el-table-column>
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.row"
				@pagination="getList" />
			<!-- 搜索关键词模态框 -->
			<el-dialog title="搜索关键词" :visible.sync="is_show_in1" width="60%">
				<el-table :data="in1_data" style="width: 100%;margin-bottom: 20px;" border>
					<el-table-column prop="keyword" label="关键词"></el-table-column>
					<el-table-column prop="sort_init" label="排序"></el-table-column>
					<el-table-column prop="desc" label="说明"></el-table-column>
					<el-table-column prop="num" label="数量"></el-table-column>
				</el-table>
				<span slot="footer" class="dialog-footer">
					<el-button @click="is_show_in1 = false">返回</el-button>
				</span>
			</el-dialog>
			<!-- 其他渠道模态框 -->
			<el-dialog title="其他渠道" :visible.sync="is_show_in2" width="60%">
				<el-form label-position="left">
					<el-form-item label="图片:">
						<span v-for="(item,index) in in2_data.imgs" :key="index">
							<el-image style="width: 40px; height: 40px;margin-left: 10px;" :src="item" fit="fill"
								:preview-src-list="[item]"></el-image>
						</span>
					</el-form-item>
					<el-form-item label="备注说明:">
						<el-col :span="10">
							<el-input rows="4" type="textarea" v-model="in2_data.desc"></el-input>
						</el-col>
					</el-form-item>
					<el-form-item label="到期时间:">
						<el-col :span="5">
							<el-input rows="4" type="text" v-model="in2_data.end_time"></el-input>
						</el-col>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="is_show_in2 = false">返回</el-button>
				</span>
			</el-dialog>
			<!-- 商品搭配模态框 -->
			<el-dialog title="商品搭配" :visible.sync="is_show_collocation" width="60%">
				<el-table :data="collocation_data" style="width: 100%;margin-bottom: 20px;" border>
					<el-table-column prop="links" label="链接">
						<template slot-scope="{row}">
							<el-link type="primary" :href="row.links" target="_blank">{{row.links}}</el-link>
						</template>
					</el-table-column>
					<el-table-column prop="imgs" label="图片">
						<template slot-scope="{row}">
							<span v-for="(item,index) in row.imgs" :key="index">
								<el-image style="width: 40px; height: 40px;margin-left: 10px;" :src="item" fit="fill"
									:preview-src-list="[item]"></el-image>
							</span>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="标题"></el-table-column>
					<el-table-column prop="price" label="价格"></el-table-column>
					<el-table-column prop="sku" label="SKU"></el-table-column>
					<el-table-column prop="price_rmb" label="价格(RMB)"></el-table-column>
				</el-table>
				<span slot="footer" class="dialog-footer">
					<el-button @click="is_show_collocation = false">返回</el-button>
				</span>
			</el-dialog>
			<!-- 取消 -->
			<el-dialog title="取消" :visible.sync="is_show_cancel" width="40%">
				<el-form label-position="right" label-width="100px">
					<el-form-item label="取消原因:">
						<el-col :span="16">
							<el-input :rows="8" type="textarea" placeholder="请输入" maxlength="200" show-word-limit
								v-model="cancel_data.cause">
							</el-input>
						</el-col>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="is_show_cancel = false">返回</el-button>
					<el-button :loading="this.$store.state.ajaxLoading" type="primary" @click="cancel2()">确定</el-button>
				</span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import {
		taskList,
		getPc,
		excelToken,
		taskCancel
	} from '@/api/jd_task'
	import request from '@/tool/request'
	import {
		parseTime
	} from '@/tool/index'
	import Qs from 'qs'
	import Pagination from '@/components/Pagination' // 基于分页的二级包装
	import Dtp from '@/components/Ele/dateTimePicker.vue' // 时间选择组件
	import {
		getToken,
	} from '@/tool/cookie'
	export default {
		components: {
			Pagination,
			Dtp
		},
		data() {
			return {
				total: 0, // 总条数
				listQuery: null,
				data_list: [], // 表格数据
				loading: true,
				is_show_in1: false,
				in1_data: [],
				is_show_in2: false,
				in2_data: [],
				is_show_collocation: false,
				collocation_data: [],
				platform_list: [],
				state_all: [],
				store_list:[],
				is_show_cancel: false,
				cancel_data: {
					'id': '',
					'cause': '',
				}
			};
		},
		filters: {
			parseTime,
		},
		created() {
			this.getPc();
			this.resetSearchData()
			this.getList()
		},
		methods: {
			keySearch() { // 搜索
				this.listQuery.page = 1
				this.getList()
			},
			resetSearchData() { // 重置listQuery搜索数据
				this.listQuery = {
					page: 1,
					row: 10,
					search: {
						platform: '',
						state: '',
						id: '',
						shop_id: '',
						start_time: '',
						end_time: '',
					},
				}
			},
			getPc() {
				getPc(Qs.stringify()).then(response => {
					this.platform_list = response.result.platform;
					this.country_list = response.result.country;
					this.state_all = response.result.state_all;
					this.store_list = response.result.store_list;
				})
			},
			getList() { // 获取列表数据
				this.loading = true;
				taskList(Qs.stringify(this.listQuery)).then(response => {
					this.data_list = response.result.items;
					this.total = response.result.total;
					this.loading = false;
				})
			},
			showIn1(val) {
				this.is_show_in1 = true;
				this.in1_data = val;
			},
			showIn2(val) {
				this.is_show_in2 = true;
				val.end_time = parseTime(val.end_time);
				this.in2_data = val;
			},
			showCollocation(val) {
				this.is_show_collocation = true;
				this.collocation_data = val;
			},
			platformChange(){
				this.keySearch();
			},
			stateChange(){
				this.keySearch();
			},
			excel() {
				// 获取exceltoken
				excelToken(Qs.stringify()).then(response => {
					let token = response.result.token;
					if (token) {
						let xid = getToken('login_uid');
						window.open(process.env.VUE_APP_ADMIN_BASE_URL+"/TaskExcel/taskList?xid="+xid+"&token=" + token,
							"_blank");
					}
				})
			},
			// 取消
			cancel(val) {
				this.is_show_cancel = true;
				this.cancel_data.id = val.id;
				this.cancel_data.cause = '';
			},
			cancel2() {
				taskCancel(Qs.stringify(this.cancel_data)).then(response => {
					this.is_show_cancel = false;
					this.getList();
					this.$message({
						showClose: true,
						message: '取消成功',
						type: 'success'
					});
				})
			},
		}
	}
</script>
<style>
	.el-radio {
		margin-right: 0px;
	}
</style>
